import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { EmployeeListItemResponse } from '@modules/employees/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import {
  EMPLOYEES_LIST_API_URL,
  EMPLOYEES_LIST_PERMISSIONS,
  EMPLOYEES_LIST_QUERY_KEY,
} from '@modules/employees/constants';
import { keepPreviousData } from '@tanstack/vue-query';

export default function useEmployeesListQuery(
  tableState: Ref<ITableState>,
): IContextQueryResult<ITableDataResponse<EmployeeListItemResponse>, Error> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<EmployeeListItemResponse>>({
    queryKey: [EMPLOYEES_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<EmployeeListItemResponse>>(
      EMPLOYEES_LIST_API_URL,
      tableState.value,
      {
        signal,
        permission: EMPLOYEES_LIST_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
